import { useState } from "react";
import { toast } from "react-toastify";
import { Button, ModalDefault, Text } from "@ficatranquilo/contabilidade.com-ui";
import useService from "../../hooks/useService";
import { formatCompetencia } from "../ow";

/**
 * Confirmação da exclusão de um cronograma: na aba Pagamentos do contrato e no
 * detalhe do pagamento. Só para cronograma pendente e sem nota (quem abre confere).
 *
 * Props:
 * - schedule: cronograma como vem da API
 * - onClose
 * - onDeleted: depois de excluir (recarregar ou voltar para a lista)
 */
export default function DeleteScheduleModal({ schedule, onClose, onDeleted }) {
  const paymentScheduleService = useService("payment-schedules");
  const [loading, setLoading] = useState(false);

  function close() {
    if (!loading) onClose();
  }

  async function confirm() {
    setLoading(true);
    try {
      const result = await paymentScheduleService.remove(schedule.id);
      if (result && !result.error) {
        toast.success(result.msg || "Cronograma excluído!");
        setLoading(false);
        onDeleted();
        return;
      }
      // Erro com { error: true } vem do sendError do service, que já mostrou o toast
      if (!result?.error) toast.error("Erro ao excluir cronograma");
    } catch (err) {
      toast.error("Erro ao excluir cronograma");
    }
    setLoading(false);
  }

  const competence = { month: Number(schedule.reference_month), year: Number(schedule.reference_year) };

  return (
    <ModalDefault
      $showModal
      $setShowModal={close}
      $noClose={loading}
      $size="medium"
      $title="Excluir cronograma?"
      $contentBackground="N0"
      $footer={
        <>
          <Button $text="Cancelar" $variant="outline" $noWidth $isDisabled={loading} $action={close} />
          <Button $text="Excluir" $variant="danger" $noWidth $isLoading={loading} $action={confirm} />
        </>
      }>
      <Text
        $text="O cronograma de <strong>%s</strong> será excluído. Esta ação não poderá ser desfeita pela interface."
        $replaces={[formatCompetencia(competence, true)]}
        $variant="paragraph_small_medium"
        $color="N700"
        $colorEmphasis="N900"
      />
    </ModalDefault>
  );
}
